// extracted by mini-css-extract-plugin
export default {"labeledMachineTestsPanel":"DataLabels_labeledMachineTestsPanel__wmYHj","machineListPanel":"DataLabels_machineListPanel__qCN2d"};